import React, { useState, useMemo, useContext } from 'react';
import ReactECharts from 'echarts-for-react';
import { FilterContext } from '../../../context/Filter';

const BarChart = ({ data }) => {
    const [year2024, setYear2024] = useState(false);
    const { open } = useContext(FilterContext);

    // Custom sorting function for age ranges
    const sortAgeRanges = (a, b) => {
        const getStartAge = (ageStr) => {
            if (ageStr.includes('>=10')) return 10;
            const match = ageStr.match(/^(\d+)/);
            return match ? parseInt(match[1]) : 0;
        };
        return getStartAge(a.key.Age_in_Years) - getStartAge(b.key.Age_in_Years);
    };

    // Process and sort the incoming data
    const chartData = useMemo(() => {
        if (!data || data.length === 0) return { categories: [], values: [] };

        const sortedData = [...data].sort(sortAgeRanges);

        const categories = sortedData.map(item =>
            item.key.Age_in_Years.replace(/_/g, ' ')
        ); // Replace underscores with spaces

        const values = sortedData.map(item => item.doc_count);

        return { categories, values };
    }, [data]);

    const option = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow',
            },
            formatter: function (params) {
                // Clean up tooltip label
                const param = params[0];
                const label = param.name.replace(/_/g, ' ');
                return `${label}: ${param.value}`;
            },
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '10%',
            containLabel: true,
        },
        xAxis: [
            {
                type: 'category',
                data: chartData.categories,
                axisTick: {
                    alignWithLabel: true,
                },
                name: 'Ageing (years)',
                nameLocation: 'center',
                nameGap: 40,
                nameTextStyle: {
                    fontSize: 14,
                    fontWeight: 'bold',
                },
            },
        ],
        yAxis: [
            {
                type: 'value',
                splitLine: { show: false },
            },
        ],
        series: [
            {
                name: 'Vehicle Count',
                type: 'bar',
                barWidth: '60%',
                data: chartData.values,
                itemStyle: {
                    color: '#5DADE2',
                    borderWidth: 0,
                    borderColor: 'transparent',
                },
            },
        ],
    };

    return (
        <div className="w-96 md:w-full h-full">
            <ReactECharts option={option} style={{ height: '380px', width: '100%' }} />
        </div>
    );
};

export default BarChart;
